import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/useI18n';
import { StoreBadges } from './StoreBadges';

export function DownloadCta() {
  const { t } = useI18n();

  return (
    <section className="download-cta" id="download">
      <div>
        <p className="eyebrow">{t('download.eyebrow')}</p>
        <h2>{t('download.title')}</h2>
        <p>{t('download.text')}</p>
      </div>
      <div className="download-actions">
        <StoreBadges />
        <Link className="button ghost" to="/download">
          {t('download.more')}
          <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  );
}
